import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { Loader2 } from "lucide-react";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useI18n } from "../i18n";
import { api, formatError } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Cinematic } from "../components/Layout";

export default function Login() {
  const { t } = useI18n();
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [useEmail, setUseEmail] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { identifier: useEmail ? email : phone || "", password });
      signIn(data);
      nav(data.user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) { setError(formatError(err)); }
    finally { setBusy(false); }
  };

  return (
    <Cinematic>
    <section className="mx-auto flex min-h-[calc(100vh-150px)] max-w-xl items-center px-5 py-16">
      <form onSubmit={submit} className="lux-card w-full space-y-6 p-8 sm:p-10 fade-up" data-testid="login-form">
        <div>
          <h1 className="font-serif text-4xl font-bold">{t("login_title")}</h1>
          <p className="mt-2 text-muted-foreground">{t("login_sub")}</p>
        </div>
        {useEmail ? (
          <div className="space-y-2"><Label>{t("f_email")}</Label><Input type="email" className="h-11" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" /></div>
        ) : (
          <div className="space-y-2"><Label>{t("f_phone")}</Label><PhoneInput international defaultCountry="ET" value={phone} onChange={setPhone} data-testid="login-phone-input" /></div>
        )}
        <div className="space-y-2"><Label>{t("login_password")}</Label><Input type="password" className="h-11" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password-input" /></div>
        {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-gold w-full" data-testid="login-submit-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />}{t("login_btn")}</button>
        <div className="flex flex-wrap items-center justify-between gap-2 text-sm">
          <button type="button" onClick={() => setUseEmail(!useEmail)} className="text-muted-foreground underline-offset-4 hover:underline" data-testid="login-toggle-method">
            {useEmail ? t("login_use_phone") : t("login_use_email")}
          </button>
          <span>{t("login_no_account")} <Link to="/register" className="font-semibold" style={{ color: "var(--gold)" }} data-testid="login-register-link">{t("nav_register")}</Link></span>
        </div>
      </form>
    </section>
    </Cinematic>
  );
}
